interface AuthHeaderProps {
  heading: string;
  description: string;
}

export const AuthHeader = ({ heading, description }: AuthHeaderProps) => {
  return (
    <div className="flex flex-col gap-3 px-4 md:px-6 lg:px-8">
      <h1 className="font-semibold text-2xl md:text-3xl xl:text-4xl">
        {heading}
      </h1>
      <p className="text-base md:text-lg lg:text-xl">{description}</p>
    </div>
  );
};
